<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="primary">
      <ion-button (click)="menuProfileOpen($event)">
        <ion-icon name="ellipsis-vertical-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center">Perfil del usuario</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- <ion-segment (ionChange)="segmentChanged($event)" value="datos">
    <ion-segment-button value="datos">
      <ion-label> Perfil </ion-label>
    </ion-segment-button>
    <ion-segment-button value="pagos">
      <ion-label> Pagos </ion-label>
    </ion-segment-button>
  </ion-segment> -->
  <div class="tab" *ngIf="isGeneralVersion">
    <ion-segment-button tab="home" (click)="segmentChanged('datos')">
      <ion-label [color]="segment==='datos'?'primary':null">Perfil</ion-label>
    </ion-segment-button>
    <ion-segment-button tab="home"  (click)="segmentChanged('pagos')">
      <ion-label [color]="segment==='pagos'?'primary':null">Pagos</ion-label>
    </ion-segment-button>
  </div>

  <ng-container *ngIf="segment==='datos'">
    <ion-card color="light" >
      <div class="img-wrapper">
        <img [src]="avatar.value" />
        <ion-button color="light" (click)="changeAvatar()">
          <ion-icon slot="icon-only" name="camera-outline" color="medium">
          </ion-icon>
        </ion-button>
      </div>
      <!-- TITLE -->
      <ion-card-title
        class="ion-text-center"
        style="text-transform: uppercase; font-weight: bold"
        color="primary"
      >
        {{name.value}}</ion-card-title
      >
      <ion-card-content class="ion-text-center">
        <form (ngSubmit)="edit()" [formGroup]="credentials">
          <div class="input-group">
            <!-- USERNAME -->
            <ion-item>
              <ion-label position="stacked">Nombre</ion-label>
              <ion-input
                type="text"
                placeholder="Nombre"
                formControlName="name"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(name.dirty || name.touched) && name.errors"
              class="errors"
            >
              <span *ngIf="name.errors?.required">Nombre es requerido</span>
              <span *ngIf="name.errors?.name">Nombre invalido</span>
            </div>

            <!-- EMAIL -->

            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input
                type="email"
                placeholder="Email"
                formControlName="email"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(email.dirty || email.touched) && email.errors"
              class="errors"
            >
              <span *ngIf="email.errors?.required">Email es requerido</span>
              <span *ngIf="email.errors?.email">Formato de email invalido</span>
            </div>

            <!-- PASSWORD -->
            <!-- <ion-item>
          <ion-label position="stacked">Contraseña</ion-label>
          <ion-input
            type="password"
            placeholder="Contraseña"
            formControlName="password"
          ></ion-input>
        </ion-item>
        <div
          *ngIf="(password.dirty || password.touched) && password.errors"
          class="errors"
        >
          <span *ngIf="password.errors?.required">Password is required</span>
          <span *ngIf="password.errors?.minlength"
            >Password needs to be 6 characters</span
          >
        </div> -->
            <!-- BIRTHDATE -->
            <ion-item class="no-hover">
              <ion-label position="stacked">Fecha de nacimiento</ion-label>
              <ion-datetime-button datetime="datetime"></ion-datetime-button>
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  <ion-datetime style="color: black;" [showDefaultButtons]="true"
                    doneText="Aceptar" cancelText="Cancelar"
                    id="datetime" presentation="date"
                    formControlName="fecha_nacimiento"
                    [preferWheel]="true"
                    >
                  </ion-datetime>
                </ng-template>
              </ion-modal>
                <!-- <ion-datetime
                  displayFormat="DD MM YYYY"
                  placeholder="Seleccionar fecha"
                  formControlName="fecha_nacimiento"
                  [buttons]="customPickerOptions.buttons"
                ></ion-datetime> -->
            </ion-item>
            <div
              *ngIf="(fecha_nacimiento.dirty || fecha_nacimiento.touched) && fecha_nacimiento.errors"
              class="errors"
            >
              <span *ngIf="fecha_nacimiento.errors?.required"
                >Fecha de nacimiento es reuqerido</span
              >
            </div>
            <!-- GENDER -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Género</ion-label>
              <ion-select placeholder="Género" formControlName="sexo">
                <ion-select-option
                  *ngFor="let sex of sexList; let i=index"
                  value="{{sex.id}}"
                  >{{sex.nombre}}</ion-select-option
                >
              </ion-select>
            </ion-item>
            <div
              *ngIf="(sexo.dirty || sexo.touched) && sexo.errors"
              class="errors"
            >
              <span *ngIf="sexo.errors?.required">Genero es requerido</span>
            </div>
            <!-- PAIS -->

            <ion-item class="no-hover">
              <ion-label position="stacked">País</ion-label>
              <ion-select
                placeholder="País"
                formControlName="pais_id"
                [disabled]="countryList.length===0"
              >
                <ion-select-option
                  *ngFor="let country of countryList; let i=index"
                  value="{{country.id}}"
                  >{{country.nombre}}</ion-select-option
                >
              </ion-select>
            </ion-item>
            <div
              *ngIf="(pais_id.dirty || pais_id.touched) && pais_id.errors"
              class="errors"
            >
              <span *ngIf="pais_id.errors?.required">pais_id is required</span>
            </div>
            <!-- TELEFONO -->

            <ion-item>
              <ion-label position="stacked">Teléfono</ion-label>
              <ion-input
                type="text"
                formControlName="telefono"
                (keypress)="numericOnly($event)"
                inputmode="numeric"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(telefono.dirty || telefono.touched) && telefono.errors"
              class="errors"
            >
              <span *ngIf="telefono.errors?.pattern"
                >Solo se permiten caracteres numericos</span
              >
              <span *ngIf="telefono.errors?.required"
                >Telefono es requerido</span
              >
            </div>
            <!-- TIEMPO -->

            <ion-item>
              <ion-label position="stacked"
                >Tiempo disponible (en minutos)</ion-label
              >
              <ion-input
                type="text"
                formControlName="tiempo_disponible"
                inputmode="numeric"
                (keypress)="numericOnly($event)"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(tiempo_disponible.dirty || tiempo_disponible.touched) && tiempo_disponible.errors"
              class="errors"
            >
              <span *ngIf="tiempo_disponible.errors?.pattern"
                >Solo se permiten caracteres numericos</span
              >
            </div>
          </div>

          <ion-button
            type="submit"
            expand="block"
            [disabled]="!credentials.valid"
          >
            Guardar
          </ion-button>
        </form>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <ng-container *ngIf="segment==='pagos'">
    <app-subscriptions
      [realizedPayments]="realizedPayments"
      [isLoading]="isLoading"
      (reloadProfile)="reloadProfile($event)"
    ></app-subscriptions>
    <ng-container *ngIf="isExpired">
      <app-timer [date]="expDate"></app-timer>
    </ng-container>
  </ng-container>

  <!-- CALENDARIO  -->
  <!-- <ng-container>
    <ion-card
      color="light"
      class="animate__animated animate__slideInUp animate__fast"
    >
      <ion-item lines="none" (click)="expandCalendar()" color="light">
        <ion-icon name="calendar-outline" slot="start" size="large"></ion-icon>
        <p>Calendario entrenamientos completados</p>
        <ion-icon
          name="chevron-up-outline"
          slot="end"
          *ngIf="calendarExpanded"
        ></ion-icon>
        <ion-icon
          name="chevron-down-outline"
          slot="end"
          *ngIf="!calendarExpanded"
        ></ion-icon>
      </ion-item>

      <ion-card-content>
        <app-expandable expandHeight="500px" [expanded]="calendarExpanded">
          some content
        </app-expandable>
      </ion-card-content>
    </ion-card>
  </ng-container> -->

  <!-- <ion-title>Progreso</ion-title> -->

  <!-- <ion-fab vertical="top" horizontal="end" slot="fixed" edge>
    <ion-fab-button (click)="logout()" color="danger">
      <ion-icon name="log-out-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button>
      <ion-icon name="ellipsis-vertical-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="bottom">
      <ion-fab-button (click)="logout()" color="danger">
        <ion-icon name="log-out-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab> -->
</ion-content>
